import React from "react";
import { Link } from "react-router";
import { Container, Header, List } from "semantic-ui-react";

function WebsocketTestClient() {
  return (
    <Container fluid>
      <Header as="h2" textAlign="center">
        WebSocket Test Client
      </Header>
      <Header dividing>Introduction</Header>
      The{" "}
      <Link to="/developer-tools/websocket-test-client">
        WebSocket Test Client
      </Link>{" "}
      page will have a WebSocket test client which is a tool used by developers
      to establish, monitor, and test real-time WebSocket connections between a
      client and a server in a secure way. It provides a user-friendly interface
      (or CLI) that lets you: Connect to a WebSocket server, Send messages,
      Receive and view responses in real-time.
      <br />
      <Header dividing>How to Use the WebSocket Test Client?</Header>
      <List as="ol">
        <List.Item as="li">
          <b>Enter the WebSocket URL</b>
          <List.List as="ol">
            <List.Item as="li">
              Locate the WebSocket URL field at the top of the client.
            </List.Item>
            <List.Item as="li">
              Input the WebSocket endpoint you wish to test (e.g.,
              wss://example.com/socket).
            </List.Item>
          </List.List>
        </List.Item>
        <List.Item as="li">
          <b>Provide the authentication token</b>
          <List.List as="ol">
            <List.Item as="li">
              In the Auth Token field, enter your authentication token if the
              WebSocket server requires one.
            </List.Item>
            <List.Item as="li">
              This token is usually a JWT or another form of access token
              provided upon successful login or registration
            </List.Item>
          </List.List>
        </List.Item>
        <List.Item as="li">
          <b>Open the connection</b>
          <List.List as="ol">
            <List.Item as="li">
              Click the Open button to initiate the connection.
            </List.Item>
            <List.Item as="li">
              Wait for the Status indicator to display Open, confirming a
              successful connection to the server.
            </List.Item>
          </List.List>
        </List.Item>
        <List.Item as="li">
          <b>Enter the request payload</b>
          <List.List as="ol">
            <List.Item as="li">
              In the Request Payload box, type the message or JSON payload you
              wish to send.
            </List.Item>
            <List.Item as="li">
              Use the Prettify button to format your payload for better
              readability.
            </List.Item>
            <List.Item as="li">
              Use the Clear button to remove all content from the payload box if
              you need to start over.
            </List.Item>
          </List.List>
        </List.Item>
        <List.Item as="li">
          <b>Send the request</b>
          <List.List as="ol">
            <List.Item as="li">
              Once you entered the request payload an the connection is open,
              the send button will be enabled. Click the Send button.
            </List.Item>
            <List.Item as="li">
              The client will send your payload to the connected WebSocket URL.
            </List.Item>
          </List.List>
        </List.Item>
        <List.Item as="li">
          <b>View Responses</b>
          <List.List as="ol">
            <List.Item as="li">
              Responses from the server will appear in the Response text
              Box(read-only).
            </List.Item>
            <List.Item as="li">
              Responses are displayed in real-time as they are received.
            </List.Item>
          </List.List>
        </List.Item>
      </List>
      <Header dividing>Troubleshooting</Header>
      <List as="ol">
        <List.Item as="li">
          <b>Connection Fails to Open</b>
          <List.List as="ol">
            <List.Item as="li">
              Monitor the Status indicator to confirm you're connected before
              sending payloads.
            </List.Item>
            <List.Item as="li">
              Double-check the WebSocket URL for typos or incorrect endpoints.
            </List.Item>
            <List.Item as="li">
              Verify that the server is running and accessible.
            </List.Item>
          </List.List>
        </List.Item>

        <List.Item as="li">
          <b>Authentication errors</b>
          <List.List as="ol">
            <List.Item as="li">
              Ensure the Auth token is correctly entered.
            </List.Item>
            <List.Item as="li">
              Verify that th token has the permissions.
            </List.Item>
            <List.Item as="li">
              Confirm that the toek has not expired.
            </List.Item>
          </List.List>
        </List.Item>
        <List.Item as="li">
          <b>No responses received</b>
          <List.List as="ol">
            <List.Item as="li">
              Confirm that the server is programmed to send responses for the
              messages you are sending.
            </List.Item>
            <List.Item as="li">
              Check if your payload meets the server's expected format and
              requirements.
            </List.Item>
          </List.List>
        </List.Item>
        <List.Item as="li">
          <b>Unexpected behaviour</b>
          <List.List as="ol">
            <List.Item as="li">
              Review the server logs if you have access.
            </List.Item>
            <List.Item as="li">
              Consult the API documentation for any specific instructions or
              limitations.
            </List.Item>
          </List.List>
        </List.Item>
      </List>
    </Container>
  );
}

export default WebsocketTestClient;
